<template>
  <div class="containerComponent">
    <Header />
    <AppMain />
    <Bottom />
  </div>
</template>

<script>
import { Header, Bottom } from '@/components/index'
import { AppMain } from './components/index';
export default {
  name: "Layout",
  components: {AppMain, Header, Bottom },
  data() {
    return {};
  }
}
</script>

<style scoped>

</style>
